__turbopack_context__.v({
  "className": "great_vibes_1a940bd-module__CZFflq__className",
});
